import * as yup from 'yup';

export const IndividualImportValidationSchema = yup.object().shape({
    importType: yup.string().required('Import type is required').nullable(),
    file: yup.mixed().test(
        'fileIsRequired',
        'File is required',
        function (item) {
            return (this.parent.file !== undefined && this.parent.file !== null && this.parent.file.size > 0)
        }
    ),
    eeScorecards: yup
        .array()
        .test(
            'eeOrBeeRequired',
            'Please select at least one EE or BEE scorecard',
            function (item) {
                return ((this.parent.eeScorecards !== undefined && this.parent.eeScorecards.length > 0) || (this.parent.beeScorecards !== undefined && this.parent.beeScorecards.length > 0))
            }
        ),
    beeScorecards: yup
        .array()
        .test(
            'beeOrEeRequired',
            'Please select at least one BEE or EE scorecard',
            function (item) {
                return ((this.parent.eeScorecards !== undefined && this.parent.eeScorecards.length > 0) || (this.parent.beeScorecards !== undefined && this.parent.beeScorecards.length > 0))
            }
        )
});


